"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require("./selector.js"),
  parseSelector = _require.parseSelector,
  matchesRule = _require.matchesRule;
var _require2 = require("./html-utils.js"),
  getClassNames = _require2.getClassNames;
var pushArray = require("./push-array.js");
function compareSpecificity(obj1, obj2) {
  var a = obj1.specificity;
  var b = obj2.specificity;
  if (a.A !== b.A) {
    return a.A - b.A;
  } else if (a.B !== b.B) {
    return a.B - b.B;
  }
  return a.C - b.C;
}
function addCustomProperties(element, transformer) {
  if (element.implicit) {
    return;
  }
  var htmlStyle = "";
  var allRules = [];
  if (transformer.tagStyleSheet) {
    allRules = transformer.tagStyleSheet.stylesheet.rules || [];
  }
  if (transformer.styleSheet) {
    pushArray(allRules, transformer.styleSheet.stylesheet.rules || []);
  }
  var matchingStyle = [];
  allRules.forEach(function (_ref) {
    var selectors = _ref.selectors,
      _ref$declarations = _ref.declarations,
      declarations = _ref$declarations === void 0 ? [] : _ref$declarations,
      type = _ref.type,
      specificities = _ref.specificities;
    if (type !== "rule") {
      return;
    }
    selectors.forEach(function (selector, i) {
      var rules;
      if (transformer.ignoreCssErrors) {
        try {
          rules = parseSelector(selector);
        } catch (e) {
          rules = [];
        }
      } else {
        rules = parseSelector(selector);
      }
      // silent: options.ignoreCssErrors,
      if (rules.some(matchesRule.bind(null, element))) {
        var specificity = specificities[i];
        var style = "";
        declarations.forEach(function (declaration) {
          style += "".concat(declaration.property, ": ").concat(declaration.value, ";");
        });
        matchingStyle.push({
          selector: selector,
          style: style,
          specificity: specificity
        });
      }
    });
  });
  matchingStyle.sort(compareSpecificity);
  matchingStyle.forEach(function (obj) {
    htmlStyle += obj.style;
  });
  element.customProperties = transformer.elementCustomizer(_objectSpread(_objectSpread({
    classNames: element.attribs ? getClassNames(element) : []
  }, element), {}, {
    styleDefaults: transformer.styleDefaults,
    styleIds: transformer.styleIds,
    part: transformer.part,
    matches: function matches(selector) {
      var rules = parseSelector(selector);
      if (rules.some(matchesRule.bind(null, element))) {
        return true;
      }
    }
  }));
  if (htmlStyle.length > 0) {
    element.customProperties || (element.customProperties = {});
    element.customProperties.htmlStyle = htmlStyle + (element.customProperties.htmlStyle || "");
  }
}
module.exports = function addAllCustomProperties(element, transformer) {
  if (element.length != null) {
    element.forEach(function (children) {
      if (children.type === "text") {
        return;
      }
      addAllCustomProperties(children, transformer);
    });
  }
  addCustomProperties(element, transformer);
  if (element.children) {
    element.children.forEach(function (children) {
      if (children.type === "text") {
        return;
      }
      addAllCustomProperties(children, transformer);
    });
  }
};